'use client';

import { c as _c } from "react/compiler-runtime";
import OptimizedImage from '@/components/OptimizedImage';
import { motion } from 'framer-motion';
import { useTranslations } from 'next-intl';
import Link from 'next/link';
import IconCalendar from '@/components/assets/icon_calendar.svg';
import IconLocation from '@/components/assets/icon_location.svg';
import IconTime from '@/components/assets/icon_time.svg';
import SectionSeparator from '@/components/SectionSeparator';
import { Separator } from '@/components/ui/separator';
import ViverseButton from '@/components/ViverseButton';
import LogoHtc from '@/public/images/brands/logo-htc.png';
import LogoLittlePrince from '@/public/images/brands/logo-little-prince.png';
import LogoMedialink from '@/public/images/brands/logo-medialink.png';
import LogoViverseText from '@/public/images/brands/logo-viverse-text.png';
import LogoWevr from '@/public/images/brands/logo-wevr.png';
import LittlePrinceExperienceBackground from '@/public/images/profile/little-prince-experience-background.png';
type LittlePrinceExperienceProps = {
  enableRichProfile: boolean;
};
const logos = [{
  src: LogoHtc.src,
  alt: 'HTC'
}, {
  src: LogoViverseText.src,
  alt: 'VIVERSE'
}, {
  src: LogoLittlePrince.src,
  alt: 'Little Prince'
}, {
  src: LogoMedialink.src,
  alt: 'Medialink'
}, {
  src: LogoWevr.src,
  alt: 'Wevr'
}];
function LittlePrinceExperience(t0) {
  const $ = _c(70);
  const {
    enableRichProfile
  } = t0;
  const t = useTranslations();
  if (!enableRichProfile) {
    return null;
  }
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <SectionSeparator />;
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] !== t) {
    t2 = t("profile.little-prince-experience.title");
    $[1] = t;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] !== t2) {
    t3 = <h2 className="header-4 md:header-3">{t2}</h2>;
    $[3] = t2;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] !== t) {
    t4 = t("profile.little-prince-experience.description");
    $[5] = t;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  let t5;
  if ($[7] !== t4) {
    t5 = <p>{t4}</p>;
    $[7] = t4;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  let t6;
  if ($[9] !== t) {
    t6 = t("profile.little-prince-experience.description-2");
    $[9] = t;
    $[10] = t6;
  } else {
    t6 = $[10];
  }
  let t7;
  if ($[11] !== t6) {
    t7 = <p>{t6}</p>;
    $[11] = t6;
    $[12] = t7;
  } else {
    t7 = $[12];
  }
  let t8;
  if ($[13] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = {
      backgroundImage: "linear-gradient(164.23deg, rgba(255, 255, 255, 0.048) 0%, rgba(255, 255, 255, 0.024) 50%, rgba(255, 255, 255, 0.012) 100%)"
    };
    $[13] = t8;
  } else {
    t8 = $[13];
  }
  let t9;
  if ($[14] !== t) {
    t9 = t("profile.little-prince-experience.location-place");
    $[14] = t;
    $[15] = t9;
  } else {
    t9 = $[15];
  }
  let t10;
  if ($[16] !== t9) {
    t10 = <h3 className="text-[18px] leading-[27px] font-bold tracking-[-0.18px] text-[rgba(255,255,255,0.95)]">{t9}</h3>;
    $[16] = t9;
    $[17] = t10;
  } else {
    t10 = $[17];
  }
  let t11;
  if ($[18] === Symbol.for("react.memo_cache_sentinel")) {
    t11 = <IconLocation className="size-[15px] shrink-0" />;
    $[18] = t11;
  } else {
    t11 = $[18];
  }
  let t12;
  if ($[19] !== t) {
    t12 = t("profile.little-prince-experience.location-address");
    $[19] = t;
    $[20] = t12;
  } else {
    t12 = $[20];
  }
  let t13;
  if ($[21] !== t12) {
    t13 = <div className="flex items-center gap-2">{t11}<span className="text-[15px] leading-[22.5px] font-medium text-[rgba(255,255,255,0.75)]">{t12}</span></div>;
    $[21] = t12;
    $[22] = t13;
  } else {
    t13 = $[22];
  }
  let t14;
  if ($[23] !== t10 || $[24] !== t13) {
    t14 = <div className="flex flex-col gap-2.5">{t10}{t13}</div>;
    $[23] = t10;
    $[24] = t13;
    $[25] = t14;
  } else {
    t14 = $[25];
  }
  let t15;
  if ($[26] === Symbol.for("react.memo_cache_sentinel")) {
    t15 = <div className="h-px w-full bg-gradient-to-r from-transparent via-[rgba(255,255,255,0.15)] to-transparent" />;
    $[26] = t15;
  } else {
    t15 = $[26];
  }
  let t16;
  if ($[27] === Symbol.for("react.memo_cache_sentinel")) {
    t16 = <IconCalendar className="size-4 shrink-0" />;
    $[27] = t16;
  } else {
    t16 = $[27];
  }
  let t17;
  if ($[28] !== t) {
    t17 = t("profile.little-prince-experience.period-value");
    $[28] = t;
    $[29] = t17;
  } else {
    t17 = $[29];
  }
  let t18;
  if ($[30] !== t17) {
    t18 = <div className="flex items-center gap-2.5">{t16}<span className="text-sm leading-[22px] font-semibold tracking-[0.15px] text-[rgba(255,255,255,0.9)]">{t17}</span></div>;
    $[30] = t17;
    $[31] = t18;
  } else {
    t18 = $[31];
  }
  let t19;
  if ($[32] === Symbol.for("react.memo_cache_sentinel")) {
    t19 = <IconTime className="size-4 shrink-0" />;
    $[32] = t19;
  } else {
    t19 = $[32];
  }
  let t20;
  if ($[33] !== t) {
    t20 = t("profile.little-prince-experience.experience-value");
    $[33] = t;
    $[34] = t20;
  } else {
    t20 = $[34];
  }
  let t21;
  if ($[35] !== t20) {
    t21 = <div className="flex items-center gap-2.5">{t19}<span className="text-sm leading-[22px] font-semibold tracking-[0.15px] text-[rgba(255,255,255,0.9)]">{t20}</span></div>;
    $[35] = t20;
    $[36] = t21;
  } else {
    t21 = $[36];
  }
  let t22;
  if ($[37] !== t18 || $[38] !== t21) {
    t22 = <div className="flex flex-col gap-0 lg:flex-row lg:items-center lg:gap-8">{t18}{t21}</div>;
    $[37] = t18;
    $[38] = t21;
    $[39] = t22;
  } else {
    t22 = $[39];
  }
  let t23;
  if ($[40] !== t14 || $[41] !== t22) {
    t23 = <div className="1.5xl:max-w-[600px] relative flex flex-col gap-5 rounded-[28px] p-6" style={t8}>{t14}{t15}{t22}</div>;
    $[40] = t14;
    $[41] = t22;
    $[42] = t23;
  } else {
    t23 = $[42];
  }
  let t24;
  if ($[43] === Symbol.for("react.memo_cache_sentinel")) {
    t24 = <motion.div className="pointer-events-none absolute inset-0" style={{
      background: "linear-gradient(135deg, rgba(0, 160, 203, 0.20) 0%, rgba(5, 137, 201, 0.10) 50%, rgba(0, 0, 0, 0.00) 100%)",
      filter: "blur(64px)"
    }} initial={{
      opacity: 0
    }} animate={{
      opacity: 0.6
    }} transition={{
      duration: 0.6
    }} />;
    $[43] = t24;
  } else {
    t24 = $[43];
  }
  let t25;
  if ($[44] !== t23 || $[45] !== t5 || $[46] !== t7) {
    t25 = <div className="md:body body-1 1.5xl:min-w-[680px] flex flex-col gap-9 text-white md:text-white lg:w-full lg:min-w-[492px]">{t5}{t7}{t23}{t24}</div>;
    $[44] = t23;
    $[45] = t5;
    $[46] = t7;
    $[47] = t25;
  } else {
    t25 = $[47];
  }
  let t26;
  if ($[48] !== t) {
    t26 = t("profile.little-prince-experience.cta");
    $[48] = t;
    $[49] = t26;
  } else {
    t26 = $[49];
  }
  let t27;
  if ($[50] !== t26) {
    t27 = <Link target="_blank" href="https://www.ntt.com/business/lp/lbielp.html" className="w-fit"><ViverseButton className="w-fit py-2">{t26}</ViverseButton></Link>;
    $[50] = t26;
    $[51] = t27;
  } else {
    t27 = $[51];
  }
  let t28;
  if ($[52] !== t25 || $[53] !== t27 || $[54] !== t3) {
    t28 = <div className="z-interactive my-auto flex flex-col gap-9">{t3}{t25}{t27}</div>;
    $[52] = t25;
    $[53] = t27;
    $[54] = t3;
    $[55] = t28;
  } else {
    t28 = $[55];
  }
  let t29;
  if ($[56] === Symbol.for("react.memo_cache_sentinel")) {
    t29 = <div className="1.5xl:mb-[5%] 1.5xl:aspect-[518/360] 1.5xl:min-w-[518px] 1.5xl:max-w-[518px] relative aspect-[302/116] size-full max-md:w-[84.4%] md:aspect-[704/116] lg:my-auto lg:aspect-[371/427] lg:max-w-[371px] lg:min-w-[371px]"><motion.div className="absolute inset-[-10px]" style={{
        background: "linear-gradient(135deg, rgba(0, 160, 203, 0.20) 0%, rgba(5, 137, 201, 0.10) 50%, rgba(0, 0, 0, 0.00) 100%)",
        filter: "blur(64px)"
      }} initial={{
        opacity: 0
      }} animate={{
        opacity: 0.6
      }} transition={{
        duration: 0.8
      }} /><OptimizedImage src={LittlePrinceExperienceBackground.src} alt="Little Prince Experience Background" className="rounded-3xl object-none object-[55%_45%] md:object-cover md:object-[50%_30%]" fill={true} /></div>;
    $[56] = t29;
  } else {
    t29 = $[56];
  }
  let t30;
  if ($[57] !== t28) {
    t30 = <div className="1.5xl:mx-[104px] relative mx-4 flex min-h-[463px] flex-col-reverse gap-8 md:mx-8 lg:mx-[72px] lg:flex-row lg:justify-between">{t28}{t29}</div>;
    $[57] = t28;
    $[58] = t30;
  } else {
    t30 = $[58];
  }
  let t31;
  if ($[59] !== t) {
    t31 = t("profile.little-prince-experience.disclaimer");
    $[59] = t;
    $[60] = t31;
  } else {
    t31 = $[60];
  }
  let t32;
  if ($[61] !== t31) {
    t32 = <p className="subheader-4 text-vive-primary-20 px-4 text-center font-normal italic md:px-0">{t31}</p>;
    $[61] = t31;
    $[62] = t32;
  } else {
    t32 = $[62];
  }
  let t33;
  if ($[63] === Symbol.for("react.memo_cache_sentinel")) {
    t33 = <div className="1.5xl:px-[104px] px-4 md:px-8 lg:px-[72px]"><Separator className="bg-vive-primary-20/10" /></div>;
    $[63] = t33;
  } else {
    t33 = $[63];
  }
  let t34;
  if ($[64] !== t30 || $[65] !== t32) {
    t34 = <div className="flex flex-col gap-8">{t30}{t32}{t33}</div>;
    $[64] = t30;
    $[65] = t32;
    $[66] = t34;
  } else {
    t34 = $[66];
  }
  let t35;
  if ($[67] === Symbol.for("react.memo_cache_sentinel")) {
    t35 = <div className="1.5xl:pb-[106px] flex flex-col gap-4 px-4 pt-2 pb-10 md:px-8 md:pt-4 md:pb-[128px]"><div className="1.5xl:gap-10 flex flex-wrap items-center justify-center gap-6 lg:gap-6">{logos.map(_temp)}</div><p className="text-center text-[10px] opacity-80 md:text-[14px]">Le Petit Prince® Property of POMASE – 2025  Licensed through Medialink</p></div>;
    $[67] = t35;
  } else {
    t35 = $[67];
  }
  let t36;
  if ($[68] !== t34) {
    t36 = <>{t1}<section id="embrace-the-journey" data-section="profile-lp-experience" className="relative scroll-mt-40 lg:scroll-mt-44">{t34}{t35}</section></>;
    $[68] = t34;
    $[69] = t36;
  } else {
    t36 = $[69];
  }
  return t36;
}
function _temp(t0) {
  const {
    src,
    alt
  } = t0;
  return <OptimizedImage key={alt} src={src} alt={alt} width={200} height={48} className="h-12 w-auto object-contain md:h-16" style={{
    width: "auto",
    height: "100%"
  }} />;
}
export default LittlePrinceExperience;